import { a as _inherits, b as _createSuper, c as _createClass, d as _classCallCheck, h as _wrapNativeSuper } from './_rollupPluginBabelHelpers-cfc9a02f.js';

var SectionFooter = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SectionFooter, _HTMLElement);
  var _super = _createSuper(SectionFooter);
  function SectionFooter() {
    var _this;
    _classCallCheck(this, SectionFooter);
    _this = _super.call(this);
    _this.countChildren();
    return _this;
  }
  _createClass(SectionFooter, [{
    key: "countChildren",
    value: function countChildren() {
      var children = this.querySelectorAll(":scope > *");
      var counts = {
        above720: 0,
        below720: 0
      };
      children.forEach(function (child) {
        if (child.className.includes("hidden")) return; // If hidden class present, it is not visible at any size

        if (child.getAttribute("data-hide-below-720") !== "true") {
          counts.below720++;
        }
        counts.above720++;
      });
      this.setAttribute("data-children-visible-above-720", counts.above720);
      this.setAttribute("data-children-visible-below-720", counts.below720);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.observer = new MutationObserver(this.countChildren.bind(this));
      this.observer.observe(this, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.observer.disconnect();
    }
  }]);
  return SectionFooter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("section-footer-component")) {
  customElements.define("section-footer-component", SectionFooter);
}

export { SectionFooter as default };

// ABRE CARRINHO LATERAL AO CLICAR NO BOTÃO COMPRAR
document.addEventListener('click', (e) => {
  const addToCartBtn = e.target.closest('.product-item__quick-add-beneath .quantity-input__button, .product-item__quick-add-beneath .product-item__quick-add, .product-form__submit');
  
  if (addToCartBtn) {
    e.preventDefault();
    
    setTimeout(() => {
      document.querySelector('.quick-cart__wrapper')?.classList.add('active');
    }, 900); 
  }
});

// BOTÃO COMPRAR AGORA
class ProductBuyNow {
  constructor() {
    this.init();
  }

  init() {
    this.setupBuyNowButtons();
  }

  setupBuyNowButtons() {
    const buyNowButtons = document.querySelectorAll('[data-buy-now]');
    
    buyNowButtons.forEach(button => {
      button.removeEventListener('click', this.handleBuyNowBound);
      
      button.addEventListener('click', (e) => {
        this.handleBuyNow(e);
      });
    });
  }

  async handleBuyNow(e) {
    e.preventDefault();
    const button = e.target.closest('[data-buy-now]');
    const form = button.closest('form[data-product-form]');
    
    if (button.hasAttribute('data-processing')) {
      return;
    }
    
    button.setAttribute('data-processing', 'true');
    this.showLoading(button);
    
    try {
      const formData = new FormData(form);
      const quantity = this.getSelectedQuantity(form);
      
      formData.set('quantity', quantity);
      
      console.log('Enviando para o carrinho:', {
        quantity: quantity,
        id: formData.get('id')
      });
      
      // Adicionar produto ao carrinho
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (!addResponse.ok) {
        const errorText = await addResponse.text();
        throw new Error(`Erro ${addResponse.status}: ${errorText}`);
      }
      
      const result = await addResponse.json();
      console.log('Sucesso:', result);
      
      // Redirecionar para o checkout
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('Erro no Buy Now:', error);
      this.hideLoading(button);
      
      // Mostrar mensagem de erro específica
      let errorMessage = 'Erro ao processar compra. Tente novamente.';
      
      if (error.message.includes('422') || error.message.includes('Unprocessable Entity')) {
        errorMessage = 'Produto indisponível ou variante inválida.';
      } else if (error.message.includes('404')) {
        errorMessage = 'Produto não encontrado.';
      }
      
      this.showError(button, errorMessage);
    } finally {
      button.removeAttribute('data-processing');
    }
  }

  getSelectedQuantity(form) {

      const input = form.querySelector('input[name="updates[]"]');
      if (input && input.value && !isNaN(input.value)) {
        const quantity = parseInt(input.value);
        if (quantity > 0) {
          return quantity.toString();
        }
      }
    
    
    // Fallback para 1
    return '1';
  }

  showLoading(button) {
    button.disabled = true;
    
    // Salvar texto original
    const originalText = button.innerHTML;
    button.setAttribute('data-original-text', originalText);
    
    // Mostrar texto de loading
    const loadingText = button.getAttribute('data-loading-text') || 'Adicionando...';
    button.innerHTML = `${loadingText} <div class="btn__loading-wrap product-form__buy-now-loading" style="display: inline-block; margin-left: 8px;"><div class="btn__loading-bar"></div></div>`;
    
    button.style.opacity = '0.7';
    button.style.cursor = 'wait';
  }

  hideLoading(button) {
    button.disabled = false;
    
    // Restaurar texto original
    const originalText = button.getAttribute('data-original-text');
    if (originalText) {
      button.innerHTML = originalText;
    }
    
    button.style.opacity = '1';
    button.style.cursor = 'pointer';
    
    // Limpar atributos temporários
    button.removeAttribute('data-original-text');
  }

  showError(button, message) {
    // Remover erros anteriores
    const existingError = button.parentNode.querySelector('.buy-now-error');
    if (existingError) {
      existingError.remove();
    }
    
    // Criar elemento de erro
    const errorElement = document.createElement('div');
    errorElement.className = 'buy-now-error';
    errorElement.style.cssText = `
      background: #ffebee;
      color: #c62828;
      padding: 10px;
      margin-top: 8px;
      border-radius: 4px;
      border: 1px solid #ffcdd2;
      font-size: 14px;
      text-align: center;
    `;
    errorElement.textContent = message;
    
    // Inserir após o botão
    button.parentNode.insertBefore(errorElement, button.nextSibling);
    
    // Remover após 5 segundos
    setTimeout(() => {
      if (errorElement.parentNode) {
        errorElement.parentNode.removeChild(errorElement);
      }
    }, 5000);
  }

  // Método para resetar todos os botões (útil quando a página é recarregada)
  resetAllButtons() {
    const buttons = document.querySelectorAll('[data-buy-now]');
    buttons.forEach(button => {
      this.hideLoading(button);
      button.removeAttribute('data-processing');
      
      // Remover erros
      const errors = button.parentNode.querySelectorAll('.buy-now-error');
      errors.forEach(error => error.remove());
    });
  }
}

// Inicializar e gerenciar estados
document.addEventListener('DOMContentLoaded', () => {
  const buyNowManager = new ProductBuyNow();
  
  // Resetar todos os botões quando a página carrega
  buyNowManager.resetAllButtons();
});

// Resetar quando a página for mostrada novamente (voltar do checkout)
window.addEventListener('pageshow', (event) => {
  if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
    const buyNowManager = new ProductBuyNow();
    buyNowManager.resetAllButtons();
  }
});

// Para temas que usam AJAX navigation
document.addEventListener('ajaxComplete', () => {
  setTimeout(() => {
    new ProductBuyNow();
  }, 100);
});




